import React from 'react';
import Chip from '@material-ui/core/Chip';
import { useHome } from './HomeContext';

export default function TabIndi() {
    const { intervalo, setIntervalo, setIsLoadingTable } = useHome();

    const handleClick = (value) => {
        if (intervalo !== value) {
            setIsLoadingTable(true);
            setIntervalo(value);
        }
    };

    return (
        <div className="kpi-filter-chips">
            <Chip
                label="Corrida"
                clickable
                color={intervalo === 0 ? 'primary' : 'default'}
                variant={intervalo === 0 ? 'default' : 'outlined'}
                onClick={() => handleClick(0)}
                className="kpi-filter-chip"
            />
            <Chip
                label="Acumulado día"
                clickable
                color={intervalo === 1 ? 'primary' : 'default'}
                variant={intervalo === 1 ? 'default' : 'outlined'}
                onClick={() => handleClick(1)}
                className="kpi-filter-chip"
            />
        </div>
    );
}
